import * as Yup from 'yup';
import { ccEmailsValid, CC_EMAILS_MAX } from '../helpers/parseCcEmails';

export const inviteCustomerFormSchema = Yup.object().shape({
    name: Yup.string().required('Please provide the name of the customer'),
    email: Yup.string().email().required(
      'Please provide the email of the point of contact'
    ),
    contactFirstName: Yup.string().required(
      'Please provide the point of contact first name'
    ),
    contactLastName: Yup.string().required(
      'Please provide the point of contact last name'
    ),
    // Comma-separated in the form; validated with the SAME parse the service
    // uses to build the payload (parseCcEmails), so trailing commas etc. can
    // never pass one side and fail the other. Cap mirrors the API's max.
    ccEmails: Yup.string().optional().test(
      'cc-emails',
      `Enter up to ${CC_EMAILS_MAX} valid email addresses, separated by commas`,
      (value) => ccEmailsValid(value),
    ),
    organizationType: Yup.string().oneOf(['full', 'iraStandalone']).default('full'),
    apiAccess: Yup.string().oneOf(['salesGated', 'selfService']).default('salesGated'),
    // IRA standalone orgs have no mobile users; the license field is hidden
    // and the API forces licenseCount to 0 for them.
    licenseCount: Yup.number().when('organizationType', {
      is: 'iraStandalone',
      then: Yup.number().notRequired(),
      otherwise: Yup.number().required('Please put the number of licenses'),
    }),
    expiresAt: Yup.string().required(
      'Please enter the date for the subscription to expire'
    ),
  });
